import { Button, Typography } from '@mui/material';
import React from 'react'; 
import styles from './styles';
import placeHolderImage from "../../images/post_placeholder.jpeg";
import moment from 'moment';
import { Link } from 'react-router-dom';
import { HiBadgeCheck } from "react-icons/hi";
import { Box } from '@mui/system';
import theme from '../../muiTheme';


const UserAvatar = ({onClick, imageURL, url, name, bio, createdAt, sx, imageSx, infoSx, nameSx, createdAtSx, bioSx, alt, follow, verified=false}) => {

    let avatarStyle = alt ? styles.userAvatar2 : styles.userAvatar; 
    let infoStyle = alt ? styles.userInfo2 : styles.userInfo;
    let nameStyle = alt ? styles.userName2: styles.userName; 
    let createdAtStyle = alt ? styles.createdAt2 : styles.createdAt;
    let nameVariant = alt ? 'body2' : 'h6';  
    let image = imageURL || placeHolderImage; 
    let link = url || '#'; 

    const handleClick = (event) => {

        if(typeof onClick === 'function'){
            onClick(event);
        }
    }

    return (
        <div style={{...styles.avatarContainer, ...sx}} onClick={handleClick}>

            <Link to={link} style={{textDecoration: 'none'}}>
                <img style={{...avatarStyle, ...imageSx}} src={image} />
            </Link>


            <div style={{...infoStyle, ...infoSx}}>

                <div style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: '2px'
                }}>
                    {name &&

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                                alignItems: 'center',
                                ...nameStyle, 
                                ...nameSx
                            }}
                        >
                            <Link to={link} style={{textDecoration: 'none'}}>
                                <Typography variant={nameVariant} sx={{color: nameStyle.color, ...nameSx }}>{name} </Typography>
                            </Link>

                            {
                                verified &&

                                <HiBadgeCheck style={{marginLeft: '5px'}}/>
                            }
                            
                        </Box>
                        
                        
                    }

                    {
                        follow && 

                        <Button 
                            variant='main' 
                            sx={{
                                padding: '2px'
                            }}>
                            Follow
                        </Button>
                    }
                </div>
                
                
                {
                    createdAt &&
                    <Typography variant="body2" sx={{...createdAtStyle, ...createdAtSx}}>{ moment(createdAt).fromNow()}</Typography>
                }

                {
                    bio && 
                    <Typography variant="body2" sx={{...styles.bio, ...bioSx}}>{bio}</Typography>
                }
                
            </div>

        </div>
    );
}

export default UserAvatar; 